export const TREATMENT_DIRECTORY_TYPE = {
  SKIN_CONDITIONS: 'skinConditions',
  SURGICAL_ACTS: 'surgicalActs',
  NON_SURGICAL_AND_LEDS_LASERS: 'nonSurgicalAndLedsLasers',
  MICRONEEDLING: 'microneedling'
};

export default { TREATMENT_DIRECTORY_TYPE };
